import dayjs from "dayjs";

import { getHindiMonthName } from "@utils/getHindiDate";
import { store } from "@store";

const getFormattedDate = (date) => {
  const day = new Date(date).getDay();
  const month = new Date(date).getMonth();
  const d = new Date(date).getDate();
  const fullYear = new Date(date).getFullYear();
  const formattedDate = `${daysArray[day]}, ${d} ${monthsArray[month]} ${fullYear}`;
  return formattedDate;
};

export default getFormattedDate;

const today = dayjs();
const yesterday = dayjs().subtract(1, "day");
const tomorrow = dayjs().add(1, "day");

export const getDayMonthYear = (date) => {
  const en = store.getState()?.auth?.user?.language === "en";
  const d = new Date(date).getDate();
  const fullYear = new Date(date).getFullYear();
  const month = en
    ? `${getEnglishMonthName(date)}`
    : `${getHindiMonthName(date)}`;
  const formattedDate = `${d} ${month} ${fullYear}`;
  return formattedDate;
};

export const formatTimeHHMMA = (d) => {
  function z(n) {
    return (n < 10 ? "0" : "") + n;
  }
  var h = d.getHours();
  return (
    (h % 12 || 12) + ":" + z(d.getMinutes()) + " " + (h < 12 ? "am" : "pm")
  );
};

export const getDayMonthTime = (date) => {
  const en = store.getState()?.auth?.user?.language === "en";
  const dateRef = new Date(date);
  const dateRefTime = formatTimeHHMMA(dateRef);
  let createdAt = "";
  if (dayjs(date).isSame(today, "day")) {
    createdAt = en ? `Today, ${dateRefTime}` : `आज, ${dateRefTime}`;
  } else if (dayjs(date).isSame(tomorrow, "day")) {
    createdAt = en ? `Tomorrow, ${dateRefTime}` : `कल, ${dateRefTime}`;
  } else if (dayjs(date).isSame(yesterday, "day")) {
    createdAt = en ? `Yesterday, ${dateRefTime}` : `कल, ${dateRefTime}`;
  } else {
    createdAt = en
      ? `${dateRef.getDate()} ${getEnglishMonthName(date)}, ${dateRefTime}`
      : `${dateRef.getDate()} ${getHindiMonthName(date)}, ${dateRefTime}`;
  }
  return createdAt;
};

export const getDayMonth = (date) => {
  const en = store.getState()?.auth?.user?.language === "en";
  let createdAt = "";
  if (dayjs(date).isSame(today, "day")) {
    createdAt = en ? "Today" : "आज";
  } else if (dayjs(date).isSame(tomorrow, "day")) {
    createdAt = en ? "Tomorrow" : "कल";
  } else if (dayjs(date).isSame(yesterday, "day")) {
    createdAt = en ? "Yesterday" : "कल ";
  } else {
    createdAt = en
      ? `${new Date(date).getDate()} ${getEnglishMonthName(date)}`
      : `${new Date(date).getDate()} ${getHindiMonthName(date)}`;
  }
  return createdAt;
};

export const getHardDayMonth = (date) => {
  return store.getState()?.auth?.user?.language === "en"
    ? `${new Date(date).getDate()} ${getEnglishMonthName(date)}`
    : `${new Date(date).getDate()} ${getHindiMonthName(date)}`;
};

export const getMonthYear = (date) => {
  return store.getState()?.auth?.user?.language === "en"
    ? `${getEnglishMonthName(date)} ${new Date(date).getFullYear()}`
    : `${getHindiMonthName(date)} ${new Date(date).getFullYear()}`;
};

export const getEnglishMonthName = (date) => {
  return monthsArray[new Date(date).getMonth()];
};

export const monthsArray = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const daysArray = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
